import React from 'react';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { Col, Typography } from 'antd';
import { ContentIncidentForm } from './styles';
import MobileForm from '../../../components/mobileForm/MobileForm';

const ContentMobileForm = ({ mobileForm }) => {
  const pages = mobileForm?.form?.dataForm ?? [];

  return (
    <>
      {pages?.map((page) => {
        const key = page?._id;
        const label = page?.label || '';
        const fieldsList = page?.list ?? [];

        return (
          <>
            <section key={key} style={{ marginBottom: 24 }}>
              <ContentIncidentForm  align="middle">
                <Col md={1}>
                  {label ? (
                    <FeatherIcon icon="file-text" className="iconTitle" style={{ color: '#8D8E90' }} size={22} />
                  ) : null}
                </Col>

                <Col md={22}>
                  <Typography.Title level={5} className="title" style={{ margin: 0, color: '#8D8E90' }}>
                    {label}
                  </Typography.Title>
                </Col>
              </ContentIncidentForm>

              <MobileForm
                fields={fieldsList}
                formValues={mobileForm.values.mobileFormValues}
                onChange={mobileForm.values.updateFieldValue}
              />
            </section>
          </>
        );
      })}
    </>
  );
};

export default ContentMobileForm;

ContentMobileForm.propTypes = {
  mobileForm: PropTypes.object,
};
